export default __webpack_public_path__ + "static/media/ic-calendar.23311ebb.svg";